export default __webpack_public_path__ + "static/media/miscellaneous22.f4ebdd3f.png";